import React, { FC, useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Loader } from 'ncoded-component-library';
import { WithdrawButton } from '../WithdrawButton';
import LeadContext from '../../../providers/Lead/Lead.context';
import ChatIcon from 'icons/Chat.icon';
import SessionLink from '../SessionLink';

import './EnquiryStepActions.styles.scss';

type EnquiryStepActionsProps = {
  className?: string;
};

export const EnquiryStepActions: FC<EnquiryStepActionsProps> = ({
  className,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const { leadId, sessionId, enquiry, dealRoom } = useContext(LeadContext);

  const { t } = useTranslation();

  const actionButton = useMemo(() => {
    if (!sessionId || !enquiry) return null;

    return (
      <SessionLink listingEnquiryId={enquiry?._id} sessionId={sessionId} />
    );
  }, [enquiry, sessionId]);

  const classes = classNames('enquiry-step-actions', className);

  return (
    <div className={classes}>
      {isLoading && <Loader />}

      <p className="title">
        <ChatIcon />
        {t('enquiryStatus')}
      </p>

      <p>{t('yourEnquiryHasBeenSubmited')}</p>

      <div className="actions">
        {actionButton}

        <WithdrawButton
          dealId={dealRoom?._id}
          dealName={dealRoom?.name}
          leadId={leadId}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </div>
    </div>
  );
};

export default EnquiryStepActions;
